import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";

export class ValidationHelper {

  static commonValidateForm(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      control!.markAsTouched({ onlySelf: true });
    });
  }

  static getErrorValidation(formControl: AbstractControl | FormControl, overrideMsg?: string): string {
    let error = null;
    if (formControl.errors) {
      const firstKey = Object.keys(formControl.errors)[0];

      if(overrideMsg){
        return error = overrideMsg;
      }

      switch (firstKey) {
        case 'required':
          error = `ERROR.FIELD_EMPTY`;
          break;
        case 'email':
          error = `ERROR.FIELD_EMPTY`;
          break;
        case 'minlength':
          error = `Minimal ${formControl.errors.minlength.requiredLength} character`;
          break;
        case 'maxlength':
          error = `Maximal ${formControl.errors.maxlength.requiredLength} character`;
          break;
        case 'max':
          error = `Max ${formControl.errors.max.max}`;
          break;
        case 'min':
          error = `Min ${formControl.errors.min.min}`;
          break;
        case 'mismatch':
          error = `ERROR.MISMATCHED_ERR`;
          break;
        default:
          error = formControl.errors[firstKey];
          break;
      }
    }
    return error
  }
}
